import { Select } from '@nimbus-ds/components';
import { Input } from '@tiendanube/components';
import { CardWithTitle } from 'commons/components';
import Text from 'commons/components/LegacyText';
import Stack from 'commons/components/Stack';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

function Skeleton(): JSX.Element {
  const t = useTranslationShipping();
  return (
    <CardWithTitle title={t('oca.config.operational.title')}>
      <Stack column align="stretch">
        <Input.Skeleton />
        <Input.Skeleton />
        <Input.Skeleton />
        <Input.Skeleton />
        <Select.Skeleton />
        <Text.Skeleton />
        <Select.Skeleton />
      </Stack>
    </CardWithTitle>
  );
}

export default Skeleton;
